
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { movimientosXBodegas, movimientoXBodegaYProducto } from "../../../services";





export const useMovimientosXBodega = (id) => {

    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const movimientosXBodegaQuery = useQuery({
        queryKey: ['movimientos-xbodega', { page, termino, id }], 
        queryFn: () => movimientosXBodegas({ page, termino, id }),
    });


    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        movimientosXBodegaQuery,
    }
}





export const useMovimientosXBodegaYProducto = (id) => {

    const [page, setPage] = useState(0);
    // const [termino, setTermino] = useState('');

    const movimientosXBodegaYProducto = useQuery({
        queryKey: ['movimientos-xbodegaproducto', { page, id }], 
        queryFn: () => movimientoXBodegaYProducto({ page, id }),
    });

    const chagePage = (num) => {
        setPage(num - 1);
    }


    
    return {
        page,
        // Metodos
        chagePage,
        movimientosXBodegaYProducto,
    }
}





// export const useProductosQuery = () => {
    
//     const [page, setPage] = useState(0);
//     const [termino, setTermino] = useState('');

//     const productosListQuery = useQuery({
//         queryKey: ['productos-list', { page, termino }], 
//         queryFn: () => startListadoProductos({ page, termino }),
//     });
    

//     const chagePage = (num) => {
//         setPage(num - 1);
//     }

//     const chageTermino = (valor) => {
//         setPage(0);
//         setTermino(valor)
//     }

    
//     return {
//         // Estados
//         page,
//         termino,
//         // Metodos
//         chagePage,
//         chageTermino,
//         productosListQuery,
//     }
// }
